<template>
  <v-main>
    <span id="top"></span>
    <AppBar />
    <v-container>
      <v-tabs v-model="tab">
        <v-tab :ripple="false">주간</v-tab>
        <v-tab :ripple="false">월간</v-tab>
      </v-tabs>
      <div v-if="tab == 0">
        <div class="date text-center">
          <v-btn plain icon :ripple="false" style="transform: rotate(180deg);" @click="prevWeek()" ><img :src="getImage('ic_arrow_right5.svg')"></v-btn>
          <span class="px-3">{{thisWeek}}</span>
          <v-btn plain icon :ripple="false" @click="nextWeek()"><img :src="getImage('ic_arrow_right5.svg')"></v-btn>
        </div>
        <div class="chart-box mb-4">
          <div class="title" @click="sheetOpen(0)">마음 날씨<Exclamation class="icon"/></div>
          <div>
            <LineChart :height="170" :week="week" :scoreArr="scoreArr[0]" />
          </div>
        </div>
        <div class="chart-box mb-4">
          <div class="title" @click="sheetOpen(1)">몸 날씨<Exclamation class="icon"/></div>
          <div>
            <LineChart :height="170" :week="week" :scoreArr="scoreArr[1]" />
          </div>
        </div>
        <div class="chart-box mb-4">
          <div class="title" @click="sheetOpen(2)">기분 날씨<Exclamation class="icon"/></div>
          <div>
            <LineChart :height="170" :week="week" :scoreArr="scoreArr[2]" />
          </div>
        </div>
      </div>
      <div v-if="tab == 1">
        <div class="date text-center">
          <v-btn plain icon :ripple="false" style="transform: rotate(180deg);" @click="prevMonth()" ><img :src="getImage('ic_arrow_right5.svg')"></v-btn>
          <span class="px-3">{{thisMonth}}</span>
          <v-btn plain icon :ripple="false" @click="nextMonth()" ><img :src="getImage('ic_arrow_right5.svg')"></v-btn>
        </div>
        <div class="chart-box mb-4">
          <div class="title" @click="sheetOpen(0)">마음 날씨<Exclamation class="icon"/></div>
          <div>
            <LineChart :height="170" :week="week" :scoreArr="scoreArr[0]" />
          </div>
        </div>
        <div class="chart-box mb-4">
          <div class="title" @click="sheetOpen(1)">몸 날씨<Exclamation class="icon"/></div>
          <div>
            <LineChart :height="170" :week="week" :scoreArr="scoreArr[1]" />
          </div>
        </div>
        <div class="chart-box mb-4">
          <div class="title" @click="sheetOpen(2)">기분 날씨<Exclamation class="icon"/></div>
          <div>
            <LineChart :height="170" :week="week" :scoreArr="scoreArr[2]" />
          </div>
        </div>
      </div>
      <WeatherSheet :sheet="sheet" :flag="sheetFlag" @sheetClose="sheetClose"/>
    </v-container>
  </v-main>
</template>
<script>
import LineChart from '@/components/chart/LineChart'
import Exclamation from '@/components/icons/Exclamation2';
import WeatherSheet from '@/components/layout/bottomSheet/WeatherSheet';
import moment from 'moment';
import store from '../../store'
export default {
    data: () => ({
         tab: 0,
         sheet:false,
         sheetFlag:0,
         weekYn:'Y',
         today:'',
         month:'',
         startDt:'',
         endDt:'',
         thisWeek:"",
         thisMonth:"",
         week:[],
         scoreArr:[[],[],[]],
         fixToday:'',
         fixMonth:'',
    }),
    components:{
        LineChart,
        Exclamation,
        WeatherSheet
    },
    watch : {
        tab(){
            // console.log("this.tab : ", this.tab)
            if(this.tab > 0){
                this.weekYn = 'N'
                this.getMonth()
            }else{
                this.weekYn = 'Y'
                this.getToday()
            }
            // console.log("this.weekYn : ", this.weekYn)
        },
        today(){
            this.getWeekData(this.today)
        },
        month(){
            this.getMonthData(this.month)
        }
    },
    mounted() {
        this.getToday() // 오늘 날짜 구함
      this.$vuetify.goTo('#top')
    },
    methods:{
        async getUnitMindWeatherReply() {
            await store.dispatch('getUnitMindWeatherReply', this.$_payload('so',[{'userKey': this.$store.state.auth.authUser.userKey}
                                                                                , {'weekYn': this.weekYn}
                                                                                , {'startDt': this.startDt}
                                                                                , {'endDt': this.endDt}
                                                                            ]))
                .then(res => {
                if (res.success) {

                    // 배열 초기화
                    this.week.splice(0, this.week.length)
                    this.scoreArr[0].splice(0, this.scoreArr[0].length)
                    this.scoreArr[1].splice(0, this.scoreArr[1].length)
                    this.scoreArr[2].splice(0, this.scoreArr[2].length)

                    if(this.weekYn == 'Y'){ // 주간

                        this.week.push('일','월','화','수','목','금','토')

                        res.data.forEach((obj,i) => {
                            // console.log('obj : ', obj)
                            if(obj.replyList != null){
                                // obj.replyList.forEach((reply) => {
                                //     this.scoreArr[i].push(reply.score)

                                //     if(i == 0){
                                //         this.week.push(reply.dayOfWeek)
                                //     }
                                // });
                                this.week.forEach((week) => {
                                    // console.log("week : ",week)
                                    var score = "없음"
                                    obj.replyList.forEach((reply) => {
                                        // console.log("reply.dayOfWeek : ",reply.dayOfWeek)
                                        if(week == reply.dayOfWeek){
                                            // cmpr = true
                                            score = reply.score
                                        }
                                    })
                                    this.scoreArr[i].push(score)
                                })
                                // console.log("week end : ",i)
                            }
                        });
                    } else {    // 월간

                        res.data.forEach((obj,i) => {
                            // console.log('obj : ', obj)
                            if(obj.replyList != null){
                                obj.replyList.forEach((reply) => {
                                    this.scoreArr[i].push(reply.score)

                                    if(i == 0){
                                        this.week.push(reply.weekDt+"주차")
                                    }
                                });
                            }
                        });
                    }

                } else {
                    console.log(res.msg)
                }
            })
            .catch(error => {
                console.error(error)
                // this.answer = [];
            })
            .finally(() => {})
        },
        getToday(){
            const moment = require('moment')
            const today = moment()
            this.today = today

            this.fixToday = moment()
            console.log("fixToday : ",this.fixToday)
        },
        getMonth(){
            const moment = require('moment')
            const month = moment()
            this.month = month

        },
        getWeekData(today){
            const moment = require('moment')
            // console.log("today1 : ", today.format('YYYYMMDD'))
            const weekOfMonth = (m) => m.week() - moment(m).startOf('month').week() + 1

            // console.log(today.format('YYYY년 MM월 ') + weekOfMonth(today) + '주차')
            this.thisWeek = today.format('YYYY년 MM월 ') + weekOfMonth(today) + '주차'

            // 주차 시작/종료일 구하기
            const firstDay = moment(this.today).startOf("month").format('YYYYMMDD')
            const lastDay = moment(this.today).endOf("month").format('YYYYMMDD')
            const startDt = moment(this.today).day(0).format('YYYYMMDD')
            const endDt = moment(this.today).day(6).format('YYYYMMDD')
            // console.log("월 시작일 : ",firstDay)
            // console.log("시작일 : ", startDt)
            // console.log("종료일 : ", endDt)
            // console.log("월 마지막일 : ",lastDay)

            // 주차 시작일
            if(startDt < firstDay){
                this.startDt = firstDay
            } else{
                this.startDt = startDt
            }

            // 주차 종료일
            if(endDt > lastDay){
                this.endDt = lastDay
            } else{
                this.endDt = endDt
            }

            // 데이터 조회
            this.getUnitMindWeatherReply()
        },
        prevWeek(){
            // console.log("this.today1 : ",this.today.format('YYYYMMDD'))
            // const eqToday = moment(this.today).format('YYYYMMDD')
            const eqToday = this.startDt    // 이번주차 시작일로 비교
            // console.log("eqToday : ",eqToday)
            const firstDay = moment(this.today).startOf("month").format('YYYYMMDD')
            // console.log("월 시작일 : ",firstDay)
            const day = moment(this.today).day(-7).format('YYYYMMDD')
            // console.log("day : ",day)

            if(firstDay == eqToday){
                this.today.startOf("month").subtract(1,"day") // 이전달 마지막 날짜로 이동
                // console.log("this.today2 : ",this.today.format('YYYYMMDD'))
                this.getWeekData(this.today)
            }else if(firstDay > day){
                this.today.startOf("month") // 이번달 1일로 설정
                // console.log("this.today3 : ",this.today.format('YYYYMMDD'))
                this.getWeekData(this.today)
            }else{
                this.today.day(-7) // 이전주 일요일 날짜로 이동
                this.getWeekData(this.today)
            }
        },
        nextWeek(){

            const weekOfMonth = (m) => m.week() - moment(m).startOf('month').week() + 1

            // console.log("fix : ",this.fixToday.format('YYYYMM') +''+ weekOfMonth(this.fixToday) )
            // console.log("day : ",this.today.format('YYYYMM') +''+ weekOfMonth(this.today) )
            const fixWeek = moment(this.fixToday).format('YYYYMM') +''+ weekOfMonth(this.fixToday)
            const week = moment(this.today).format('YYYYMM') +''+ weekOfMonth(this.today)

            if(week < fixWeek){

                const lastDay = moment(this.today).endOf("month").format('YYYYMMDD')
                // console.log("월 마지막일2 : ",lastDay)
                const day = moment(this.today).day(+7).format('YYYYMMDD')
                // console.log("day : ",day)

                // 주차 증가시 월변경 되었을때 현재월에서 +1day
                if(lastDay < day){
                    this.today.endOf("month").add(1,"day")
                    // console.log("this.today3 : ",this.today.format('YYYYMMDD'))
                    this.getWeekData(this.today)
                } else{
                    this.today.day(+7) // 다음주 날짜로 이동
                    this.getWeekData(this.today)
                }
            }
        },
        getMonthData(month){
            const moment = require('moment')
            this.thisMonth = month.format('YYYY년 M월 ')

            // console.log("month : ",month.format('YYYY년 M월 '))

            // 월 시작/종료일 구하기
            const firstDay = moment(this.month).startOf("month").format('YYYYMMDD')
            const lastDay = moment(this.month).endOf("month").format('YYYYMMDD')
            this.startDt = firstDay
            this.endDt = lastDay

            console.log("월 시작일 : ", this.startDt)
            console.log("월 종료일 : ",this.endDt)

            // 데이터 조회
            this.getUnitMindWeatherReply()
        },
        prevMonth(){
            this.month.subtract(1,"month") // 이전달 이동
            this.getMonthData(this.month)
        },
        nextMonth(){

            // console.log("fix : ",this.fixToday.format('YYYYMM'))
            // console.log("month : ",this.month.format('YYYYMM'))
            const fixMonth = moment(this.fixToday).format('YYYYMM')
            const month = moment(this.month).format('YYYYMMDD')

            if(month < fixMonth){
                this.month.add(1,"month") // 다음달 이동
                this.getMonthData(this.month)
            }

        },
        sheetOpen(num){
            this.sheetFlag = num;
            this.sheet = true;
        },
        sheetClose(){
             this.sheet = false;
        }

    }
}
</script>
<style lang="scss" scoped>
::v-deep.v-tabs{
    .v-tabs-bar{
        height: 40px;
        .v-slide-group__wrapper{
            background: #F7F7F7;
            border-radius: 20px;
            .v-tab{
                width: 50%;
                max-width: 50%;
                z-index: 2;
                font-size: 16px;
                color: #7260FF;
                &.v-tab--active{
                    color: #fff;
                }
            }
            .v-tabs-slider-wrapper{
                height: 40px !important;
                .v-tabs-slider{
                    border-radius: 20px;
                }
            }
        }
    }


}
.date{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    padding: 25px 0;
}
.chart-box{
    border-radius: 10px;
    border:1px solid #E6E8EA;
    padding: 20px;
    .title{
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 16px;
        color: #101010;
        margin-bottom: 10px;
        .icon{
            margin-left: 6px;
        }
    }
}
</style>
